import React from 'react';

import LoginCreds from '../../components/loginpages/LoginCreds';
import { LoginComponentProps } from '../../types/LoginFormData';
import { TSPCategory, TSPConfig } from '../types';

const cyntrxConfig: TSPConfig = {
  key: 'cyntrx',
  name: 'CyntrX',
  category: TSPCategory.CUSTOM,
  helpText: 'Input the credentials you use to log into the CyntrX web app.',
  loginComponent: (props: LoginComponentProps) => {
    return (
      <LoginCreds
        onValidityChange={props.onValidityChange}
        fields={[
          { label: 'Username', name: 'username', type: 'text', required: true },
          {
            label: 'Password',
            name: 'password',
            type: 'password',
            required: true,
          },
        ]}
      />
    );
  },
};

export default cyntrxConfig;
